import { from, useMediaQuery } from 'styles/media';

const useLogic = () => {
  const isMobile = !useMediaQuery(from.tablet);

  return { isMobile };
};

export default useLogic;
